import * as React from "react";
import * as ReactDatetimeClass from "react-datetime";
import * as moment from "moment";
import * as classNames from "classnames";

export type DateTimePickerProps = {
  className: {garbage: any},
  dateFormat: string | boolean,
  input: boolean,
  readOnly: boolean,
  timeFormat: string | boolean,
  viewMode: number | "years" | "months" | "days" | "time"
}

export type DateTimePickerActions = {
  onBlur(): void,
  onChange(value: string): void,
  onFocus(): void
}

export type DateTimePickerPropsAndActions = DateTimePickerProps & DateTimePickerActions;

class OldDateTimePicker extends React.PureComponent<DateTimePickerPropsAndActions, any> {
  constructor(props: DateTimePickerPropsAndActions) {
    super(props);
    this.onChange=this.onChange.bind(this)
  }

  onChange(val: string | moment.Moment) {
    if (!this.props.readOnly) {
          this.props.onChange(moment(val).format("DD/MM/YYYY"));
    }
  }

  render() {
    return (
      <ReactDatetimeClass
        onBlur={this.props.onBlur}
        onChange={this.onChange}
        onFocus={this.props.onFocus}
        viewMode={this.props.viewMode}
        dateFormat={this.props.dateFormat || "DD/MM/YYYY"}
        timeFormat={this.props.timeFormat || false}
        inputProps={{ 
          placeholder: typeof this.props.dateFormat == "string" ? this.props.dateFormat : "DD/MM/YYYY" ,
          className:classNames("form-control", this.props.className)
        }}
        input={this.props.input}
      />
    );
  }
}

export default OldDateTimePicker;